import { CheckoutProviderContext } from '../checkout-provider/checkout-provider.types';
import { useCheckoutProvider } from '../checkout-provider/useCheckoutProvider';

type OrderConfig = NonNullable<CheckoutProviderContext['checkoutOrderSectionConfig']>;
type OnlyWithKeys<T> = keyof {
  [K in keyof T as K extends `with${string}` ? K : never]: T[K];
};
/** Only the keys that start with 'with' */
type OrderConfigKey = OnlyWithKeys<OrderConfig>;

/** Renders the children if the section config key is true */
const WithSectionConfig = ({
  children,
  configKey,
}: {
  children: React.ReactNode;
  configKey: OrderConfigKey;
}) => {
  const { checkoutOrderSectionConfig } = useCheckoutProvider();

  // If the section config key is explicitly false, return null
  if (checkoutOrderSectionConfig?.[configKey] === false) return null;
  return <>{children}</>;
};

export { WithSectionConfig };
